export class PaginationInfos {
	public totalRecordsCount: number;
	public filteredRecordsCount: number;
	public LoadedRecordsRangeStart: number;
	public LoadedRecordsRangeEnd: number;
}
